import styled from 'styled-components';

export const HeaderContainer = styled.div`
	width: 100%;
	display: flex;
	padding-top: 1rem;
	padding-bottom: 1rem;
	justify-content: space-between;
`;

export const ActionContainer = styled.div`
	width: 100%;
	display: flex;
	padding: 1rem;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
	gap: 1rem;

	border-radius: 0rem 0rem 0.25rem 0.25rem;
	border-top: 1px solid ${(props) => props.theme.color.greys[200]};
	background: ${(props) => props.theme.color.greys[50]};
`;

export const ActionButtonContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
`;
